import React from "react";
import { Routes, Route } from "react-router-dom";

import { CustomSideMenu } from "../components";

import UserInfo from "../pages/account/userInfo/UserInfo";
import ProjectList from "../pages/account/projects/ProjectList";
import ProjectEdition from "../pages/account/projects/ProjectEdition";
import Dashboard from "../pages/account/dashboard/Dashboard";
import Tuto from "../pages/account/tuto/Tuto";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { userTypes } from "../enums/userTypes.enum";
import DownloadHistory from "../pages/account/downloadHistory/DownloadHistory";
import MyMembers from "../pages/account/myMembers/MyMembers";
import MyEstablishments from "../pages/account/myEstablishments/MyEstablishments";
import Credits from "../pages/account/credits/Credits";

function AccountRouter() {
    const userType = useSelector((state: RootState) => state.auth.userType);

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div>
                <CustomSideMenu />
            </div>

            <div style={{ flexGrow: 3, overflowY: 'scroll', height: '100vh' }}>
                <Routes>
                    <Route path="/" element={<UserInfo />} />
                    <Route path="/credits" element={<Credits />} />
                    
                    
                    { userType === userTypes.EDITOR &&
                        <Route path="/dashboard" element={<Dashboard />} />
                    }

                    { userType === userTypes.ESTABLISHMENT &&
                        <Route path="/my_members" element={<MyMembers />} />
                    }

                    { userType === userTypes.DV &&
                        <>
                            <Route path="/my_establishments" element={<MyEstablishments />} />
                            <Route path="/deri_academy" element={<Tuto />} />
                        </>
                    }


                    <Route path="/projects/" element={<ProjectList />} />
                    <Route path="/projects/edit" element={<ProjectEdition />} />

                    <Route path="/download_history" element={<DownloadHistory />} />
                </Routes>
            </div>
        </div>
    );
}

export default AccountRouter;